import { Component, Input } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { keyedStatusOptions as keyedOfficeStatusOptions } from 'app/core/options/office-status.opts';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';

import { OfficeComponent } from '../../../shared/components/office/office.component';
import { ProviderOfficeFaxStatusComponent } from '../provider-office-fax-status/provider-office-fax-status.component';
import { NotesForModelComponent } from '../../../shared/components/notes-for-model/notes-for-model.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-provider-office-list',
    templateUrl: './provider-office-list.component.html',
    styleUrls: ['./provider-office-list.component.scss'],
    imports: [OfficeComponent, ProviderOfficeFaxStatusComponent, NotesForModelComponent, MatProgressSpinner]
})
export class ProviderOfficeListComponent {
  @Input() providerOffices: ProviderOffice[];
  @Input() loading: boolean;

  keyedOfficeStatusOptions = keyedOfficeStatusOptions;
  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;
}
